/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 18/12/2020
 */

import * as SessionUtils from './../../../core/session_utils.js'

const cartBaseRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        data: []
    }
}

export default cartBaseRequest;